export enum UserActions {
  SET_USER_DATA = 'SET_USER_DATA',
}
